import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  loadingSpinner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%'
  }
});
